/* eslint-disable max-lines */
import { history } from 'umi'
import { message as $message } from 'antd'
import Qs from 'qs'
import { login, logout, afterLogin, bind, syncSubAccount, syncApplyCooperationNum, getTicket } from '@/services/login'
import { acquireSimpleUser } from '@/services/user'
import { getPageQuery, getTerminaDomain } from '@/utils/utils'
import { clearAuthority } from '@/utils/authority'
import { clearSkipAudit } from '@/utils/channelAudit'

import { getHome } from '@/utils/role'
import { getSource } from '@/utils/logger'
import { getToken } from '@/utils/token'
import { isSingleAppDomain, isZongHengApp, getFromBuInRegister } from '@/utils/singleApp'
import { SMS_CODE, LOGIN_SUCCESS_BIND_QR } from '@/modules/account/constance'
import { setAfterLoginFromSource, clearAfterLoginFromSource } from '@/modules/user/features/afterLoginFromSource'
import { wrapResponseData } from '@/utils/wrapRequest'

const logLogin = () => {
    getSource()
}

// 20002 触发二次登录验证 message为fid有特殊处理
const SECOND_AUTH_CODE = '20002'

const Model = {
    namespace: 'login',
    state: {
        status: undefined,
        logoutStatus: undefined, // oneself: 点击退出
    },
    effects: {
        *login({ payload }, { call, put }) {
            const { inviteId, fromSource, onSuccess, onError, needRedirect, loginType, redirect, ...restPayload } =
                payload
            try {
                const res = yield call(login, {
                    ...restPayload,
                    loginType,
                    fromBu: getFromBuInRegister(),
                })
                const { success, data, message, code, extra } = res

                const needRedirectBoolean = (loginType === SMS_CODE && extra?.isBinding === false) || needRedirect

                if (success) {
                    yield put({
                        type: 'setLoginInfo',
                        payload: {
                            loginResData: data,
                            needRedirect: needRedirectBoolean,
                            inviteId,
                            fromSource,
                            loginType,
                            noBinding: extra?.isBinding === false,
                            redirect,
                        },
                    })

                    if (onSuccess) {
                        onSuccess({ ...(res || {}), loginType })
                    }

                    return res
                } else {
                    onError && onError(res)
                    if (code !== SECOND_AUTH_CODE) {
                        message && $message.error(message)
                    }
                }
                return res
            } catch (e) {
                console.error('catchError', e)
            }

            return Promise.reject(new Error('登录失败'))
        },
        *bind({ payload }, { call, put }) {
            const {
                inviteId,
                fromSource,
                onSuccess,
                onError,
                needRedirect,
                bindType,
                hideToastErrorMessage,
                ...restPayload
            } = payload

            try {
                const res = yield call(bind, {
                    ...restPayload,
                    bindType,
                })
                const { success, data, message, code, extra } = res

                if (success) {
                    if (bindType === LOGIN_SUCCESS_BIND_QR) {
                        // 手机验证码登陆成功后-绑定二维码成功后 需要拉同步子账号接口 （用户列表绑定状态）
                        try {
                            yield call(syncSubAccount)
                        } catch (error) {
                            console.error('catchError', error)
                        }

                        if (onSuccess) {
                            onSuccess(res)
                        }

                        return res
                    }

                    yield put({
                        type: 'setLoginInfo',
                        payload: {
                            loginResData: data,
                            needRedirect,
                            inviteId,
                            fromSource,
                            bindType,
                            noBinding: extra?.isBinding === false,
                        },
                    })

                    if (onSuccess) {
                        onSuccess(res)
                    }

                    return
                } else {
                    onError && onError(res)
                    if (code !== SECOND_AUTH_CODE) {
                        !hideToastErrorMessage && message && $message.error(message)
                    }
                }
                return res
            } catch (e) {
                console.error('catchError', e)
            }

            return Promise.reject(new Error('登录失败'))
        },
        *logout({ payload }, { call, put }) {
            try {
                const { success, message } = yield call(logout)
                if (success) {
                    yield put({
                        type: 'changeLogoutStatus',
                        payload: {
                            status: 'oneself',
                        },
                    })

                    yield put({
                        type: 'changeLoginStatus',
                        payload: {
                            status: false,
                        },
                    })

                    yield put({
                        type: 'clearLoginInfo',
                        payload,
                    })
                } else {
                    $message.error(message)
                }
            } catch (error) {
                console.error('catchError', error)
            }
        },
        *agentLogin({ payload }, { put }) {
            yield put({
                type: 'user/saveToken',
                payload: payload || {},
            })
            yield put({
                type: 'changeLoginStatus',
                payload: {
                    status: true,
                },
            })

            const urlParams = new URL(window.location.href)
            const params = getPageQuery()
            let { redirect } = params

            if (redirect) {
                const redirectUrlParams = new URL(redirect)

                if (redirectUrlParams.origin === urlParams.origin) {
                    redirect = redirect.substr(urlParams.origin.length)

                    if (redirect.match(/^\/.*#/)) {
                        redirect = redirect.substr(redirect.indexOf('#') + 1)
                    }
                }
            }

            history.replace(redirect || '/')
        },
        *setLoginInfo({ payload }, { put, call }) {
            const {
                loginResData,
                needRedirect,
                inviteId,
                fromSource,
                loginType,
                noBinding,
                redirect: urlWithRedirect,
            } = payload
            yield put({
                type: 'user/saveToken',
                payload: loginResData || {},
            })
            yield put({
                type: 'changeLoginStatus',
                payload: {
                    status: true,
                },
            })

            // 引流日志
            logLogin()

            if (PROJECT_CONFIG.terminalName !== 'OP') {
                try {
                    const afterLoginRes = yield call(afterLogin, {
                        inviteId,
                        fromSource,
                    })
                    // 普通登录跳转链路也要落一次，目标端首次 getUserInfo 会从 cookie 侧读取这个值。
                    if (afterLoginRes?.success && afterLoginRes?.data) {
                        yield call(setAfterLoginFromSource, afterLoginRes.data)
                    }
                    yield call(syncApplyCooperationNum, {})
                } catch (error) {
                    console.error('catchError', error)
                }
            }

            if (needRedirect) {
                let redirectPage = '/'
                if (PROJECT_CONFIG.terminalName === 'OP') {
                    history.replace(redirectPage)
                } else {
                    acquireSimpleUser()
                        .then(async response => {
                            const { success, data, message } = response ?? {}
                            if (!success) {
                                $message.error(message)
                                history.replace('/role/choose')
                                return
                            }
                            const { lastLoginSide } = data
                            const params = getPageQuery()

                            const { redirect: redirectPath, redirectUrl: gylRedirectUrl } = params

                            let redirect = urlWithRedirect || redirectPath || gylRedirectUrl
                            let redirectInWhiteList = false

                            if (redirect) {
                                try {
                                    const redirectUrl = decodeURIComponent(redirect)
                                    const redirectUrlObj = new URL(redirectUrl)
                                    const hostname = redirectUrlObj.hostname
                                    const hostArr = hostname.split('.')
                                    const rootServer = hostArr.splice(hostArr.length - 2, 2).join('.')
                                    redirectInWhiteList = PROJECT_CONFIG.permissionHost.indexOf(rootServer) !== -1

                                    // 是否是寻合作域名
                                    const isTtDhuo = hostname.includes('ttdahuo.com')

                                    if (redirectInWhiteList && isTtDhuo) {
                                        if (redirectUrlObj) {
                                            const curQuery = Qs.parse(redirectUrlObj.search, {
                                                ignoreQueryPrefix: true,
                                            })

                                            const newRedirectQuery = {
                                                ...curQuery,
                                            }

                                            const _gt = await wrapResponseData(getTicket)

                                            if (_gt) {
                                                Object.assign(newRedirectQuery, {
                                                    _gt,
                                                })
                                            } else {
                                                Object.assign(newRedirectQuery, {
                                                    token: getToken(),
                                                })
                                            }

                                            const newRedirectLocation = {
                                                origin: redirectUrlObj.origin,
                                                pathname: redirectUrlObj.pathname,
                                                hash: redirectUrlObj.hash,
                                                query: newRedirectQuery,
                                                search: Qs.stringify(newRedirectQuery, { addQueryPrefix: true }),
                                            }

                                            redirect = encodeURIComponent(
                                                `${redirectUrlObj.origin}${history.createHref(newRedirectLocation)}`,
                                            )
                                        }
                                    }
                                } catch (error) {
                                    console.error('catchError', error)
                                }
                            }
                            if (redirectInWhiteList) {
                                redirectPage = decodeURIComponent(redirect)
                            } else if (lastLoginSide) {
                                redirectPage = getHome(lastLoginSide)
                            } else {
                                // 市场版只有供应侧，无需选择角色
                                if (isSingleAppDomain || isZongHengApp) {
                                    redirectPage = getTerminaDomain(PROJECT_CONFIG.supplierTerminalName)
                                } else {
                                    redirectPage = '/role/choose'
                                }
                            }

                            if (loginType === SMS_CODE && noBinding) {
                                window.location.href = `/user/bindqr?refer=${encodeURIComponent(redirectPage)}`
                            } else {
                                window.location.href = redirectPage
                            }
                        })
                        .catch(() => {
                            redirectPage = '/role/choose'

                            if (loginType === SMS_CODE && noBinding) {
                                window.location.href = `/user/bindqr?refer=${encodeURIComponent(redirectPage)}`
                            } else {
                                window.location.href = redirectPage
                            }
                        })
                }
            }
        },

        *clearLoginInfo(_, { put, call }) {
            yield call(clearAfterLoginFromSource)

            yield put({
                type: 'user/clearToken',
            })

            yield put({
                type: 'user/clearCurrentUser',
            })

            yield put({
                type: 'changeLoginStatus',
                payload: {
                    status: false,
                },
            })

            clearAuthority()
            clearSkipAudit()
        },
    },
    reducers: {
        changeLogoutStatus(state, { payload }) {
            return { ...state, logoutStatus: payload.status }
        },
        changeLoginStatus(state, { payload }) {
            return { ...state, status: payload.status, type: payload.type }
        },
    },
}
export default Model
